/* import __COLOCATED_TEMPLATE__ from './topic-edit-empty-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();